export const AssetUtils = {
	ttrMerchandiseImage(merchandiseId) {
		return `https://s7d5.scene7.com/is/image/ToryBurchLLC/TB_${merchandiseId.replace(/-/g, "_")}`;
	},
};
